import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

export default function ModalReworkSalary(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [show_add_salary, SetShowAddSalary] = useState(false);
  const [init_data, SetInitData] = useState({});
  const [amount_value, SetAmountValue] = useState("");

  useEffect(() => {
    console.log("ModalReworkSalary On mount :", props);
    let myModal1 = document.getElementById("ReworkSalaryModel");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("close_data :", close_data);
      SetShowAddSalary(false);
      SetAmountValue("");
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalReworkSalary On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ReworkSalaryModel"),
        {}
      );
      get_rework_salary_init();
      myModal.show();
    }
  }, [props.open]);

  async function get_rework_salary_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        task_id: props.data.id,
      },
    };
    let data = await api("/outlet/rework_task_salary_init", pass_data);
    console.log("rework_task_salary_init response :", data);
    if (data.response.hasOwnProperty("data")) {
      SetInitData(data.response.data);
    }
  }

  async function rework_task_salary_pay() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        task_id: props.data.id,
      },
      post: {
        amount: amount_value,
      },
    };
    let data = await api("/outlet/rework_task_salary_pay", pass_data);
    console.log("rework_task_salary_pay response :", data);
    if (data.response.hasOwnProperty("status")) {
      if (data.response.status) {
        SetInitData(data.response.data);
        SetShowAddSalary(false);
      }
    }
  }

  return (
    <div
      className="modal fade"
      id="ReworkSalaryModel"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" id="ModalLabel">
              <h5>Rework Salary</h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            <div className="row">
              {!show_add_salary ? (
                <div className="">
                  <div className="">
                    <p>Salary Amount : {init_data.salary}</p>
                    <p>Salary Paid : {init_data.salary_paid}</p>
                    {/* <p>Salary Payable : {init_data.salary_payable}</p>
                    <p>Salary Quantity : {init_data.salary_quantity}</p> */}
                  </div>
                  <div className="d-flex">
                    <p>Salary Paid List</p>
                    <button
                      className="btn-light-outline ms-auto"
                      onClick={() => {
                        console.log("Add Salary");
                        SetShowAddSalary(true);
                        // SetAmountValue(init_data.salary_payable);
                      }}
                    >
                      + Add
                    </button>
                  </div>
                  {init_data.hasOwnProperty("salary_paid_data")
                    ? init_data.salary_paid_data.map((ele: any, index: any) => (
                        <div className="d-flex" key={index}>
                          <p> Amount : {ele.amount}</p>
                          <p> Created At : {ele.created_at}</p>
                          <p>
                            Created By : {ele.created_user} @
                            {ele.created_username}
                          </p>
                        </div>
                      ))
                    : null}
                </div>
              ) : (
                <div className="">
                  <div className="d-flex">
                    <p>Add Salary</p>
                  </div>
                  <div className="">
                    <p>Salary Amount : {init_data.salary}</p>
                    <p>Salary Paid : {init_data.salary_paid}</p>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Price</label>
                    <input
                      className="form-control"
                      value={amount_value}
                      onChange={(e) => {
                        console.log("price :", e.target.value);
                        SetAmountValue(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            {!show_add_salary ? (
              <>
                <button
                  type="button"
                  className="btn btn-light-outline"
                  onClick={() => {
                    let item = close_data;
                    item.action = "close";
                    SetCloseData(item);
                    myModal.hide();
                  }}
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-light-outline"
                  onClick={() => {
                    console.log("Cancel");
                    SetShowAddSalary(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-light-outline"
                  onClick={() => {
                    console.log("Save");
                    rework_task_salary_pay();
                  }}
                >
                  Save
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
